import { AccountUserClientType } from "../../../clients/AccountUser";

export const deleteUserApi = (
  accountUserClient: AccountUserClientType,
  apiInstance: API.Client
) => async ( uid: string ) => {
  await accountUserClient.delete( uid );
  return apiInstance.Entity.collection( 'user' ).delete( uid );
};
